var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaypalSolid(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4H2a2 2 0 00-2 2v12a2 2 0 002 2h20a2 2 0 002-2V6a2 2 0 00-2-2zm-7.28 4c.165.17.282.38.34.61.057.233.074.473.05.71h-.49a4.92 4.92 0 00-.8-.06h-2.44a.42.42 0 00-.16 0 .37.37 0 00-.22.29l-.34 1.78-.24 1.5v.1L10 15.55H8.11l1.32-8.12a.09.09 0 010-.07H12.61a2.73 2.73 0 012.11.64zM13 14.22a2.85 2.85 0 003.17-2.47 2.11 2.11 0 00-.31-1.87 1.52 1.52 0 00-.44-.34A2 2 0 0015 7.75 3.11 3.11 0 0012.61 7H9.5a.45.45 0 00-.47.38l-1.29 8.2a.27.27 0 00.26.31h1.95l-.13.84a.23.23 0 00.23.27h1.63a.39.39 0 00.39-.33v-.08l.3-1.93v-.11a.39.39 0 01.38-.33H13zm2.33-4.32a3.23 3.23 0 01-3.56 2.65h-1l-.64 4.1h1.57v-.07l.3-1.98v-.1a.75.75 0 01.72-.62H13c.336.002.672-.035 1-.11.293-.074.57-.199.82-.37a2.24 2.24 0 00.6-.66 3.24 3.24 0 00.38-1.06c.07-.304.086-.619.05-.93a1.31 1.31 0 00-.29-.64.89.89 0 00-.23-.21z",
    fill: "#121318"
  })));
}

export default SvgPaypalSolid;